import {
  CollectionFragment,
  CollectionQuery,
  CollectionQueryVariables,
  StandardGetHookOptions,
  useCollectionQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useCollectionImpl = withStandardGetHook<
  CollectionQuery,
  CollectionFragment,
  'collection',
  CollectionQueryVariables
>(useCollectionQuery, 'collection');

export const useCollection = (options: StandardGetHookOptions) => {
  return useCollectionImpl(options);
};
